import { render, staticRenderFns } from "./additionalChargeList.vue?vue&type=template&id=3d54c8b7&scoped=true&"
import script from "./additionalChargeList.vue?vue&type=script&lang=js&"
export * from "./additionalChargeList.vue?vue&type=script&lang=js&"
import style0 from "./additionalChargeList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./additionalChargeList.vue?vue&type=style&index=1&id=3d54c8b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54c8b7",
  null
  
)

export default component.exports